import {Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CompanyService } from 'src/app/company.service';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { VenueService } from 'src/app/_services/venue.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/_services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/_services/event.service';
import { ApiService } from 'src/app/_services/api.service';
import { SearchEventModel } from "../../../_models/Event/SearchEventModel";
import { EventModel } from "../../../_models/Event/EventModel";
import { TabView } from "primeng/tabview";
import { filter } from "rxjs/operators";
import { EventStatusTabMapping } from "../../../_models/Constants/EventStatusTabMapping";

@Component({
  selector: 'app-events-panel',
  templateUrl: './events-panel.component.html',
  styleUrls: ['./events-panel.component.scss']
})
export class EventsPanelComponent implements OnInit, OnDestroy {
  @ViewChild('tabView') tabview: TabView;
  @ViewChildren("dataContainer") dataContainers: QueryList<any>;

  public eventSubscription: Subscription;
  public company: CompanyModel = {};
  public companyTypesString: string = '';
  public searchEventModel: SearchEventModel = new SearchEventModel();
  public eventList?: EventModel[] = [];
  public loadingPage = false;

  public totalRecords: number;
  public selectedTab: number = 0;
  public previousSelectedTab: number = 0;

  constructor(
    private companyService: CompanyService,
    private router: Router,
    private authService: AuthService,
    private venueService: VenueService,
    private eventService: EventService,
    private messageService: MessageService,
    private translate: TranslateService,
    private apiService: ApiService,
    private route: ActivatedRoute
  ) {
    authService.hideNavigationMenuEventEmitter.emit(false);
  }

  ngOnInit(): void {
    this.getCompanyDetails();
    this.getVenues();
    this.loadTabIndex();
    // this.totalRecords = this.eventService.getTotalRecords();
    this.loadingPage = true;
    this.apiService.getEvents(this.searchEventModel).subscribe();
    this.fetchEvents();
  }

  loadTabIndex(): void {
    this.route.queryParams
      .pipe(
        filter(params => params.activeIndex)
      ).subscribe(params => {
      this.selectedTab = +params.activeIndex;
      this.searchEventModel.status = EventStatusTabMapping[this.selectedTab];
    });
  }

  updateTabIndexParam(activeIndex: number): void {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: {activeIndex: activeIndex},
        queryParamsHandling: 'merge',
        replaceUrl: true
      })
  }

  fetchEvents(): void {
    this.eventSubscription = this.eventService.eventsChanged
      .subscribe(
        (events: EventModel[]) => {
          this.eventList = events;
          this.loadingPage = false;
          if (this.eventService.getEventsPageNumber() === 1 && this.dataContainers) {
            this.dataContainers.forEach(dt => dt.nativeElement.scrollTo(0, 0));
            this.searchEventModel.pageNumber = 1;
          }
        }
      );
    this.eventList = this.eventService.getEvents();
  }

  getCompanyDetails(): void {
    this.apiService.getCompanyDetails().subscribe((company: CompanyModel) => {
      this.company = company;
    });
  }

  createEvent(): void {
    if(this.company.needCompanyUpdate){
      this.messageService.add({ key: 'company-check', severity: 'info', sticky: true });
    }
    else if (this.venueService.getVenues().length == 0) {
      this.messageService.add({ key: 'venues-check', severity: 'info', sticky: true });
    } else if (this.company.isMembershipPaid || this.company.isUsingTrial) {
      this.router.navigate(['/promoter/event-manager'], { queryParams: { activeIndex: this.selectedTab } });
    } else {
      this.messageService.add({ severity: 'info', summary: this.translate.instant('PAYMENT.ACCESS_MESSAGE') });
    }
  }

  onConfirmVenuesCheck(): void {
    this.router.navigate(['/promoter/venues']);
  }

  onRejectVenuesCheck(): void {
    this.messageService.clear('venues-check');
  }

  onConfirmCompanyCheck():void{
    this.router.navigate(['/promoter/company-profile']);
  }
  onRejectCompanyCheck(): void {
    this.messageService.clear('company-check');
  }

  getVenues(): void {
    this.apiService.getVenues().subscribe();
  } 

  getBusinesTypesAsString(companyTypes: any): void {
    let temp: string[] = [];
    if (companyTypes !== undefined) {
      companyTypes.forEach((element: { name: string; }) => {
        temp.push(element.name);
      });
    }
    this.companyTypesString = temp.join(', ');
  }

  changeTabView(event: any): void {
    this.tabview.activeIndex = event.index;
    if (event.index == 4) {
      this.tabview.activeIndex = this.previousSelectedTab;
      return;
    }
    this.searchEventModel.pageNumber = 1;
    this.searchEventModel.status = EventStatusTabMapping[event.index];
    this.previousSelectedTab = this.tabview.activeIndex;
    this.updateTabIndexParam(event.index);
    this.loadingPage = true;
    this.apiService.getEvents(this.searchEventModel).subscribe();
  }

  loadMoreEvents(): void {
    this.loadingPage = true;
    this.searchEventModel.pageNumber = this.searchEventModel.pageNumber + 1;
    this.apiService.getEvents(this.searchEventModel).subscribe();
  }

  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
  }
}
